import { render, staticRenderFns } from "./dynamic-model.vue?vue&type=template&id=6b4c843a&scoped=true"
import script from "./dynamic-model.vue?vue&type=script&lang=js"
export * from "./dynamic-model.vue?vue&type=script&lang=js"
import style0 from "./dynamic-model.vue?vue&type=style&index=0&id=6b4c843a&prod&scoped=true&lang=css"
import style1 from "./dynamic-model.vue?vue&type=style&index=1&id=6b4c843a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c843a",
  null
  
)

export default component.exports